<template>
    <section>
         <div v-show="showlist">
        <sy-baselist
                hideAdd
                hideEdit
                hideDel
                :filters="filters"
                listUrl="server/business/Performance.ashx?cmd=GetPerformance"
        >
            <el-table-column prop="FName" label="绩效用户" width="120" sortable>
            </el-table-column>
            <el-table-column prop="FPerformance" label="绩效" width="400" sortable>
            </el-table-column>
            <template scope="props" slot="extendbtn">
                <el-button size="mini" class="el-icon-plus el-button el-button--text el-button--mini"  @click="showdetails(props.row)">查看记录</el-button>
            </template>
        </sy-baselist>
         </div>
          <div v-show="showdetail">
            <el-row>
            <el-col  class="toolbar">
                <el-form>
                    <el-form-item>
                        <el-tag  type="gray">{{joblist.length>0?joblist[0].FName:''}}</el-tag>
                        <a @click="showlists" style="color:#409EFF;margin-left: 20px;cursor:pointer;">&lt; 返回</a>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
            <template v-if="false">
                <el-table ref="table" :data="joblist">
                    <el-table-column prop="FName" label="人员名称" width="250" >
                    </el-table-column>
                </el-table>
            </template>
        <el-row :gutter="20">
            <el-col :span="24">
              <Record ref="record" ></Record>
            </el-col>
        </el-row>
        </div>
    </section>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    import Record from "../business/Performance_Record.vue"
    export default {
         components:{
            Record
        },
        mixins: [mixin],
        data(){
            return {
                filters: [{type: "string",name:"FName",text:"绩效用户", value: "",remote:true},
                          {type: "date",name:"FTime",text:"时间", value: null,remote:true}
                ],
                showlist:true,
                showdetail:false,
                 jobID:0,
                jobRow:{},
                joblist:[]
            }
        },
        methods:{
         showdetails(row){
                this.jobID = row.FID
                this.jobRow =row
                this.showlist=false
                this.showdetail=true
                this.joblist=[]
                this.joblist.push(this.jobRow)
                this.$refs.record._initrecord(this.jobID)
            },
              showlists(){
                this.showdetail=false
                this.showlist=true
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Performance.vue